import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { oktaTokenBaseQuery } from "@/react/services/api/api";

export const supportedValuesUrl = `/v1/vo/supported-values`;

export const supportedValuesApi = createApi({
  reducerPath: "supportedValues",
  baseQuery: oktaTokenBaseQuery(),
  endpoints: (build) => ({
    getSupportedValues: build.query({
      query: () => ({
        url: supportedValuesUrl,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetSupportedValuesQuery } = supportedValuesApi;
